import React, { useState } from "react";
import { toast } from "react-toastify";
import "./SmsPopup.css";

const SmsPopup = ({ onClose, billId }) => {

  const [mobile, setMobile] = useState("");
  const [error, setError] = useState("");
  const [countryCode, setCountryCode] = useState("+91");

  const validateMobile = (number) => {
    // Regex: allows optional +country code, then 10 digits 
    const regex = /^(\+?\d{1,3}[- ]?)?\d{10}$/; return regex.test(number);
  };

  const handleSend = () => {
    if (!mobile) {
      toast.info("Please enter a mobile number");
      return;
    }

    if (!validateMobile(mobile)) {
      setError("Enter a valid 10-digit mobile number (with optional country code)");
      return;
    }
    setError("");

    // TODO: integrate with SMS API (Twilio, MSG91, etc.)
    toast.info(`Bill #${billId} sent to ${mobile}`);
    onClose();
  };

  return (
    <div className="sms-overlay">
      <div className="sms-popup">
        <h3>📩 Send Bill via SMS</h3>
        <div className="mobile-input">
          <select value={countryCode} onChange={(e) => setCountryCode(e.target.value)} >
            <option value="+91">🇮🇳 +91</option>
            <option value="+1">🇺🇸 +1</option>
            <option value="+44">🇬🇧 +44</option>
            <option value="+61">🇦🇺 +61</option>
            <option value="+971">🇦🇪 +971</option>
          </select>
          <input
            id="mobile"
            type="tel"
            placeholder="Enter mobile number"
            value={mobile}
            onChange={(e) => setMobile(e.target.value)}
          />
        </div>
        {error && <p className="error-text">{error}</p>}
        <div className="sms-actions">
          <button className="btn-primary" onClick={handleSend}>Send</button>
          <button className="btn-secondary" onClick={onClose}>Cancel</button>
        </div>
      </div>
    </div>
  );
};
export default SmsPopup;
